import { UnitCurrentStatus, UnitsSource } from "api/units";
import type { ListingHealthLabel } from "types/landlord/address";
import { listingHealthLabelOf } from "shared/app/ListingHealth/constants";

export interface UnitsFilters {
  states: string[];
  cities: string[];
  property_group_ids: number[];
  property_ids: number[];
  unit_ids: number[];
  current_statuses: UnitCurrentStatus[];
  owner_ids: number[];
  sources: UnitsSource[];
  listing_health: ListingHealthLabel[];
  needs_lockbox: boolean;
  no_lockbox: boolean;
}

export const EMPTY_UNITS_FILTERS: UnitsFilters = {
  states: [],
  cities: [],
  property_group_ids: [],
  property_ids: [],
  unit_ids: [],
  current_statuses: [],
  owner_ids: [],
  sources: [],
  listing_health: [],
  needs_lockbox: false,
  no_lockbox: false
};

export const NO_LOCKBOX_FILTER_PARAM = "lockbox";
export const NO_LOCKBOX_FILTER_VALUE = "no_lockbox";
const LISTING_HEALTH_FILTER_PARAM = "listing_health";

const listingHealthFromSearch = (params: URLSearchParams) => [
  ...new Set(
    params
      .getAll(LISTING_HEALTH_FILTER_PARAM)
      .flatMap((value) => value.split(","))
      .map((value) => listingHealthLabelOf(value.trim()))
      .filter((label): label is ListingHealthLabel => label !== null)
  )
];

export const unitsFiltersFromSearch = (search: string): UnitsFilters => {
  const params = new URLSearchParams(search);
  return {
    ...EMPTY_UNITS_FILTERS,
    listing_health: listingHealthFromSearch(params),
    no_lockbox: params.get(NO_LOCKBOX_FILTER_PARAM) === NO_LOCKBOX_FILTER_VALUE
  };
};

export const countActiveUnitsFilters = ({
  needs_lockbox,
  no_lockbox,
  ...listFilters
}: UnitsFilters) =>
  Object.values(listFilters).reduce(
    (total, values) => total + values.length,
    Number(needs_lockbox) + Number(no_lockbox)
  );
